import { useBoolean } from '@teamsparta/react';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import type { ScrollDirection } from '@/lib/utils/businessLogics/_common/useScrollDirection';
import { useScrollDirection } from '@/lib/utils/businessLogics/_common/useScrollDirection';

export function useGetScrollDirection(
  scrollDirectionOverRide: ScrollDirection | undefined,
) {
  const defaultScrollDirection = useScrollDirection();
  const scrollDirection = scrollDirectionOverRide ?? defaultScrollDirection;

  return { scrollDirection };
}

export function useToggleSideBar() {
  const {
    value: sideBarOpen,
    toggle: toggleSideBar,
    setFalse: closeSideBar,
  } = useBoolean();
  const router = useRouter();
  useEffect(() => {
    router.events.on('routeChangeComplete', closeSideBar);
    return () => {
      router.events.off('routeChangeComplete', closeSideBar);
    };
  }, [router.events, closeSideBar]);

  return {
    sideBarOpen,
    toggleSideBar,
    closeSideBar,
  };
}
